const updates = [
  { date: '2026-07-30', title: '《庆余年2》全集上线，张若昀再续范闲传奇', tag: '新剧上线' },
  { date: '2026-07-29', title: '暑期档特辑上线：50部经典动画限时免费看', tag: '活动' },
  { date: '2026-07-28', title: '播放器全面升级：支持AI智能字幕同步翻译', tag: '功能更新' },
  { date: '2026-07-26', title: '《流浪地球3》高清版独家上线大师兄影视', tag: '独家' },
  { date: '2026-07-25', title: 'CDN节点扩容完成，华东地区播放速度提升40%', tag: '技术升级' },
  { date: '2026-07-23', title: '新增「猜你喜欢」智能推荐引擎，找片更轻松', tag: '功能更新' },
  { date: '2026-07-21', title: '《与凤行》赵丽颖林更新二搭，全集畅享', tag: '热播' },
  { date: '2026-07-20', title: 'TV版客户端更新：适配更多智能电视型号', tag: '客户端' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-600">关注大师兄影视的最新片单上架、功能更新与活动资讯。</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-background-200"></div>

          <div className="space-y-4">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 md:gap-8 pl-10 md:pl-14">
                <div className="absolute left-[11px] md:left-[19px] top-2 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>

                <div className="flex-shrink-0 w-20 md:w-24 pt-0.5">
                  <span className="text-xs md:text-sm text-foreground-500 font-mono">{item.date}</span>
                </div>

                <div className="flex-1 min-w-0 pb-5 border-b border-background-100">
                  <div className="flex items-start gap-3 flex-wrap">
                    <p className="text-sm md:text-base text-foreground-800 leading-relaxed flex-1 min-w-0">{item.title}</p>
                    <span className="flex-shrink-0 px-2.5 py-0.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}